// Blue rounding leaves a few wei behind after a full withdraw or deallocation. Below
// this floor an amount is treated as gone.
export const DUST_FLOOR_USD = 0.01

/** An unknown USD value (missing price feed) is never dust, so it never hides a real amount. */
export const isDustAllocation = (usd: number | null | undefined): boolean =>
  usd != null && usd < DUST_FLOOR_USD
